import { render, staticRenderFns } from "./orderinfo.vue?vue&type=template&id=1ec13d9c&scoped=true&"
import script from "./orderinfo.vue?vue&type=script&lang=js&"
export * from "./orderinfo.vue?vue&type=script&lang=js&"
import style0 from "./orderinfo.vue?vue&type=style&index=0&id=1ec13d9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec13d9c",
  null
  
)

export default component.exports